import apiClient, {
  apiClientWithoutInterceptor,
} from "helpers/services/http/api-client";

export const auth = {
  checkAuthAccess: () => {
    return apiClientWithoutInterceptor
      .get("/auth/check/access")
      .then((r) => r.data);
  },
};

export default auth;
